import type { SVGProps } from "react";
import * as React from "react";

const SvgAlertCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13 8a1 1 0 1 0-2 0zm-2 4a1 1 0 1 0 2 0zm1 3a1 1 0 1 0 0 2zm.01 2a1 1 0 1 0 0-2zM21 12a9 9 0 0 1-9 9v2c6.075 0 11-4.925 11-11zm-9 9a9 9 0 0 1-9-9H1c0 6.075 4.925 11 11 11zm-9-9a9 9 0 0 1 9-9V1C5.925 1 1 5.925 1 12zm9-9a9 9 0 0 1 9 9h2c0-6.075-4.925-11-11-11zm-1 5v4h2V8zm1 9h.01v-2H12z"
    />
  </svg>
);
export default SvgAlertCircle;
